/*!
* @digi1874/vue-carousel 0.1.2
* (c) 2020 Lin 07
* Released under the MIT License.
*/
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'd-carousel',
  props: {
    listData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showIndicator: {
      type: Boolean,
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    autoPlayTime: {
      type: Number,
      default: 2000
    },
    inAnimate: {
      type: String,
      default: 'fadeIn'
    },
    inAnimateOtherSide: {
      type: String,
      default: 'fadeIn'
    },
    outAnimate: {
      type: String,
      default: 'fadeOut'
    },
    outAnimateOtherSide: {
      type: String,
      default: 'fadeOut'
    },
    speed: {
      type: String,
      default: ''
    },
    waitingTime: {
      type: Number,
      default: 500
    }
  },
  data: function data() {
    var itemClasses = this.listData.map(function () {
      return 'hide';
    });
    itemClasses[0] = '';
    return {
      activeIndex: 0,
      isAutoPlay: this.autoPlay,
      playing: false,
      itemClasses: itemClasses
    };
  },
  watch: {
    listData: function listData() {
      this.startAutoPlay();
    },
    activeIndex: function activeIndex(newVal, oldVal) {
      this.handleItemClasses(newVal, oldVal);
    },
    autoPlay: function autoPlay() {
      this.startAutoPlay();
    }
  },
  mounted: function mounted() {
    this.startAutoPlay();
    window.addEventListener('blur', this.stopAutoPlay);
    window.addEventListener('focus', this.startAutoPlay);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('focus', this.startAutoPlay);
    window.removeEventListener('blur', this.stopAutoPlay);
  },
  methods: {
    stopAutoPlay: function stopAutoPlay() {
      this.isAutoPlay = false;
      clearTimeout(this.autoPlayRun.timeout);
    },
    startAutoPlay: function startAutoPlay() {
      this.isAutoPlay = this.autoPlay;
      this.autoPlayRun();
    },
    autoPlayRun: function autoPlayRun() {
      var _this = this;

      clearTimeout(this.autoPlayRun.timeout);

      if (!this.isAutoPlay || this.playing) {
        return;
      }

      this.autoPlayRun.timeout = setTimeout(function () {
        _this.isAutoPlay && _this.next();
      }, this.autoPlayTime);
    },
    goIndex: function goIndex(index) {
      if (index < 0) {
        index = this.listData.length - 1;
      } else if (index >= this.listData.length) {
        index = 0;
      }

      this.activeIndex = index;
    },
    prev: function prev() {
      !this.playing && this.goIndex(this.activeIndex - 1);
    },
    next: function next() {
      !this.playing && this.goIndex(this.activeIndex + 1);
    },
    handleItemClasses: function handleItemClasses(newIndex, oldIndex) {
      var _this2 = this;

      if (!this.listData.length || this.playing) return;
      this.stopAutoPlay();
      this.playing = true;
      var lastIndex = this.listData.length - 1;
      var isOtherSideIn = newIndex < oldIndex || newIndex === lastIndex && oldIndex === 0;

      if (newIndex === 0 && oldIndex === lastIndex) {
        isOtherSideIn = false;
      }

      var itemClasses = [];

      for (var i = 0; i < this.listData.length; i++) {
        if (i === newIndex) {
          itemClasses[i] = [isOtherSideIn ? this.inAnimateOtherSide : this.inAnimate, 'active'];
        } else if (i === oldIndex) {
          itemClasses[i] = [isOtherSideIn ? this.outAnimateOtherSide : this.outAnimate];
        } else {
          itemClasses[i] = ['hide'];
        }

        itemClasses[i].push(this.speed);
      }

      this.itemClasses = itemClasses;

      if (this.waitingTime) {
        setTimeout(function () {
          _this2.playing = false;

          _this2.startAutoPlay();
        }, this.waitingTime);
      } else {
        this.playing = false;
        this.startAutoPlay();
      }
    },
    touchstart: function touchstart(e) {
      this.stopAutoPlay();
      this.touchstart.changedTouche = e.changedTouches[0];
    },
    touchend: function touchend(e) {
      var moveX = this.touchstart.changedTouche.pageX - e.changedTouches[0].pageX;
      var moveY = this.touchstart.changedTouche.pageY - e.changedTouches[0].pageY;
      var move = Math.abs(moveY) > Math.abs(moveX) ? moveY : moveX;
      move > 0 ? this.next() : this.prev();
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "d-carousel",
    on: {
      mouseenter: _vm.stopAutoPlay,
      mouseleave: _vm.startAutoPlay,
      touchstart: _vm.touchstart,
      touchend: _vm.touchend
    }
  }, [_c("div", {
    staticClass: "d-carousel-inner"
  }, _vm._l(_vm.listData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item animated",
      class: _vm.itemClasses[index]
    }, [_vm._t("default", null, {
      record: item,
      index: index
    })], 2);
  }), 0), _vm._v(" "), _vm.showIndicator ? _c("div", {
    staticClass: "d-carousel-indicators"
  }, _vm._l(_vm.listData.length, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item",
      class: {
        active: index === _vm.activeIndex
      },
      on: {
        click: function click($event) {
          _vm.activeIndex = index;
        }
      }
    });
  }), 0) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Carousel = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

function install(Vue) {
  Vue.component(Carousel.name, Carousel);
}

var carousel = {
  install: install,
  Carousel: Carousel
};
export default carousel;
export { Carousel, install };
